import { auth, db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export interface UserProfile {
  dob: string;
  time_of_birth: string;
  place_of_birth: string;
  zodiac_sign: string;
}

export const profileService = {
  getProfile: async (): Promise<UserProfile | null> => {
    try {
      const user = auth.currentUser;
      if (!user) return null;
      
      const docRef = doc(db, 'users', user.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.dob) {
          return data as UserProfile;
        }
      }
      return null;
    } catch (error) {
      console.error('Error fetching profile:', error);
      return null;
    }
  },

  updateProfile: async (profile: UserProfile): Promise<boolean> => {
    try {
      const user = auth.currentUser;
      if (!user) return false;

      const docRef = doc(db, 'users', user.uid);
      await setDoc(docRef, profile, { merge: true });
      return true;
    } catch (error) {
      console.error('Error updating profile:', error);
      return false;
    }
  },
  
  calculateZodiacSign: (dob: string): string => {
    if (!dob) return '';
    const date = new Date(dob);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    
    if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return 'Aries';
    if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return 'Taurus';
    if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return 'Gemini';
    if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return 'Cancer';
    if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return 'Leo';
    if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return 'Virgo';
    if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return 'Libra';
    if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return 'Scorpio';
    if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return 'Sagittarius';
    if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) return 'Capricorn';
    if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return 'Aquarius';
    return 'Pisces';
  }
};
